import { render, staticRenderFns } from "./user_portrait.vue?vue&type=template&id=3b4ef128&scoped=true&"
import script from "./user_portrait.vue?vue&type=script&lang=js&"
export * from "./user_portrait.vue?vue&type=script&lang=js&"
import style0 from "./user_portrait.vue?vue&type=style&index=0&id=3b4ef128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ef128",
  null
  
)

export default component.exports